import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "dollar" })
export class DollarPipe implements PipeTransform {
  transform(value: number): string {
    return value < 0
      ? `-$${Math.round(Math.abs(value)).toLocaleString()}`
      : `$${Math.round(Math.abs(value)).toLocaleString()}`;
  }
}
